import { ApiService } from "@/services/api/ApiService";
import {
  PageAnalysisResult,
  PageViewCountRow,
  PageViewQuery,
  PageViewTotalRow,
  RouteManifestEntry,
} from "@/types/admin/page-views";

export class PageViewAnalyticsService {
  static async listDaily(query: PageViewQuery): Promise<{
    items: PageViewCountRow[];
    count: number;
    limit: number;
    offset: number;
  }> {
    return ApiService.invoke({
      resource: "analytics",
      action: "page-views",
      data: query,
    });
  }

  static async totalsByPath(query: PageViewQuery): Promise<{ items: PageViewTotalRow[] }> {
    return ApiService.invoke({
      resource: "analytics",
      action: "page-view-totals",
      data: query,
    });
  }

  static async analyzeUnusedPages(
    query: Pick<PageViewQuery, "period" | "from" | "to">,
    routeManifest: RouteManifestEntry[],
  ): Promise<PageAnalysisResult> {
    return ApiService.invoke({
      resource: "analytics",
      action: "page-view-unused-analysis",
      data: { ...query, routeManifest },
    });
  }
}
